import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Layers, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-deep-green relative overflow-hidden" data-id="element-188">
      {/* Subtle radial glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(245,158,11,0.08)_0%,_transparent_60%)] pointer-events-none" data-id="element-189" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="relative z-10 max-w-4xl mx-auto px-4 pt-5 pb-6 md:pt-12 md:pb-16 text-center" data-id="element-190">
        {/* Logo */}
        <div className="mb-4 md:mb-8" data-id="element-191">
          <span className="inline-flex items-center gap-2 text-gold font-extrabold text-sm md:text-base tracking-wider uppercase" data-id="element-192">
            🇧🇷 Portugués 360
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold text-white leading-[1.0] mb-0 md:mb-2 tracking-tight" data-id="element-193">
          Todo tu año de
          <br data-id="element-194" />
          Portugués <span className="text-gold italic" data-id="element-195">resuelto.</span>
        </h1>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex items-center justify-center max-w-md md:max-w-lg mx-auto w-full -mt-2 md:mt-0 mb-1 md:mb-3" data-id="element-196">
          <img src="https://cdn.magicpatterns.com/uploads/s1P2CoGxmatyBVguGy2Awh/195.png" alt="MegaPack Português 360 — Elite Bundle con 12 tomos y bonus" className="w-auto max-w-full max-h-[36vh] md:max-h-[420px] object-contain drop-shadow-[0_25px_50px_rgba(245,158,11,0.25)]" loading="eager" decoding="async" width={600} height={600} data-id="element-197" />
        </motion.div>

        {/* Highlighted quote */}
        <p className="text-gold font-extrabold text-base md:text-2xl mb-3 md:mb-5 italic px-2" data-id="element-198">
          "Listo para usar. Sin buscar más. Sin improvisar. Sin perder más
          domingos."
        </p>

        {/* Subtitle */}
        <p className="text-white/70 text-sm md:text-lg max-w-2xl mx-auto mb-5 md:mb-8 leading-relaxed px-3" data-id="element-199">
          El sistema para docentes de Português de todos los niveles en
          Argentina: año completo listo, sin buscar ni armar desde cero.
        </p>

        {/* Trust badges — pill cards */}
        <div className="grid grid-cols-2 md:flex md:flex-wrap md:justify-center gap-2 md:gap-3 mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-200">
          <div className="flex items-center justify-center gap-1.5 bg-white/5 border border-white/15 rounded-full py-2 px-3 md:px-4 text-white text-xs md:text-sm font-medium" data-id="element-201">
            <FileText size={14} className="text-white/60" data-id="element-202" />
            <span data-id="element-203">100% PDF</span>
          </div>
          <div className="flex items-center justify-center gap-1.5 bg-white/5 border border-white/15 rounded-full py-2 px-3 md:px-4 text-white text-xs md:text-sm font-medium" data-id="element-204">
            <Zap size={14} className="text-gold" data-id="element-205" />
            <span data-id="element-206">Acceso inmediato</span>
          </div>
          <div className="flex items-center justify-center gap-1.5 bg-white/5 border border-white/15 rounded-full py-2 px-3 md:px-4 text-white text-xs md:text-sm font-medium" data-id="element-207">
            <span data-id="element-208">🇦🇷</span>
            <span data-id="element-209">Currículo Argentino</span>
          </div>
          <div className="flex items-center justify-center gap-1.5 bg-white/5 border border-white/15 rounded-full py-2 px-3 md:px-4 text-white text-xs md:text-sm font-medium" data-id="element-210">
            <Layers size={14} className="text-white/60" data-id="element-211" />
            <span data-id="element-212">Todos los niveles</span>
          </div>
        </div>

        {/* CTA */}
        <motion.button onClick={scrollToPricing} whileTap={{
        scale: 0.98
      }} animate={{
        boxShadow: ['0px 4px 24px rgba(245,158,11,0.35)', '0px 4px 40px rgba(245,158,11,0.7)', '0px 4px 24px rgba(245,158,11,0.35)']
      }} transition={{
        boxShadow: {
          duration: 2.2,
          repeat: Infinity
        }
      }} className="w-full md:w-auto bg-gold hover:bg-yellow-400 text-deep-green font-extrabold text-base md:text-xl py-4 md:py-5 px-6 md:px-12 rounded-xl transition-colors leading-tight" data-id="element-213">
          🇧🇷 → QUIERO MIS 12 TOMOS + 6 BONUS AHORA
        </motion.button>

        {/* Micro trust */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 md:gap-x-5 gap-y-1.5 mt-5 md:mt-6 text-[10px] md:text-xs text-white/60" data-id="element-214">
          <div className="flex items-center gap-1" data-id="element-215">
            <ShieldCheck size={12} className="text-red-400" data-id="element-216" />
            <span data-id="element-217">Garantía 7 días sin preguntas</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-218">
            <Lock size={12} data-id="element-219" />
            <span data-id="element-220">Pago 100% seguro</span>
          </div>
          <div className="hidden sm:flex items-center gap-1" data-id="element-221">
            <CreditCard size={14} data-id="element-222" />
            <span data-id="element-223">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </motion.div>
    </section>;
}